export default __webpack_public_path__ + "static/media/nepal_sisters.d5736342.jpg";